import { render } from "./Children.vue?vue&type=template&id=74782f1b&scoped=true"
import script from "./Children.vue?vue&type=script&lang=ts"
export * from "./Children.vue?vue&type=script&lang=ts"

import "./Children.vue?vue&type=style&index=0&id=74782f1b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74782f1b"

export default script